<template>
  <div class="popup-wrapper">
    <div class="popup-overlay" @click="$emit('closePopup')"></div>
    <div class="popup popup--quiz-start">
      <button class="popup-close3" @click="$emit('closePopup')"></button>

      <ImageWrapper :file="quiz.idPicture"/>
      <div class="popup-title">{{quiz.name}}</div>
      <p>{{quiz.instructions}}</p>

      <div class="popup-bottom">
        <router-link class="button-icon button--submit" :to="`/${$route.params.companySlug}/quizzes/${quiz.idQuiz}/start`">Start the game <i class="icon-quiz-flag"></i></router-link>
        <button class="button" @click="$emit('closePopup')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
export default {
  name: "PopupQuizStart",
  components: {ImageWrapper},
  props: ['quiz']
}
</script>
